export const siteSettings = {
  name: "Gem X Capital",
  link: "https://gemxcapital.com",
  email: "support@gemxcapital.com",
  appLink: "https://app.gemxcapital.com",
};
